import {RDCBalancesResponse, PassiveBalancesData} from './types'
import {isNull} from 'lodash'
import {getFinsystemNumberFormat} from '../../../../../libs/utils'
import {Tooltip} from 'antd'

  const formatIfExists = (value: any, digits = 2) => {
    if (isNull(value) || value === undefined) return ''
    return getFinsystemNumberFormat(value, digits)
  }

export const mapOpeningBalances = (
  data: PassiveBalancesData,
  RDCBalances: RDCBalancesResponse | null,
): any => {
  const openingRDCBalanceUsd = RDCBalances?.openingRDCBalanceUsd ?? 0
  const openingBalanceTooltip = `Баланс на начало периода в RDC: ${getFinsystemNumberFormat(openingRDCBalanceUsd, 2)}`
  return [
    {
      key: 1,
      name: (
        <Tooltip title="Начальный остаток на всех кошельках">
          <div>Opening balance</div>
        </Tooltip>
      ),
      wallet: (
        <Tooltip title="На wallet" placement="topLeft">
          <div>{formatIfExists(data.openingBalance.wallet)}</div>
        </Tooltip>
      ),
      account: (
        <Tooltip title="На аккаунтах в метаках" placement="topLeft">
          <div>{formatIfExists(data.openingBalance.account)}</div>
        </Tooltip>
      ),
      result: (
        <Tooltip title={openingBalanceTooltip} placement="topLeft">
          <div>{formatIfExists(data.openingBalance.all)}</div>
        </Tooltip>
      ),
    },
  ]
}

export const mapPassiveBalances = (data: PassiveBalancesData, RDCBalances: RDCBalancesResponse | null): any => {
  const finalRDCBalanceUsd = RDCBalances?.finalRDCBalanceUsd ?? 0
  const openingRDCBalanceUsd = RDCBalances?.openingRDCBalanceUsd ?? 0
  const finalBalanceTooltip = `Баланс на конец периода в RDC: ${getFinsystemNumberFormat(finalRDCBalanceUsd, 2)}`
  const balanceChangeRDCTooltip = `Изменение баланса за период в RDC: ${getFinsystemNumberFormat(finalRDCBalanceUsd - openingRDCBalanceUsd, 2)}`
  const diffBalanceChange = data.balanceChange.all - (finalRDCBalanceUsd - openingRDCBalanceUsd)
  const diffBalanceChangeTooltip = `Разница между оборотами CRM (${data.balanceChange.all}) и RDC (${(finalRDCBalanceUsd - openingRDCBalanceUsd)})`

  return [
    {
      key: 1,
      name: 'Deposit',
      wallet: formatIfExists(data.deposit.wallet),
      account: formatIfExists(data.deposit.account),
      result: formatIfExists(data.deposit.all),
    },
    {
      key: 2,
      name: 'Withdrawal',
      wallet: formatIfExists(data.withdrawal.wallet),
      account: formatIfExists(data.withdrawal.account),
      result: formatIfExists(data.withdrawal.all),
    },
    {
      key: 17,
      name: 'Exchanger Transfer',
      wallet: formatIfExists(data.exTransfer.wallet),
      account: formatIfExists(data.exTransfer.account),
      result: formatIfExists(data.exTransfer.all),
    },
    {
      key: 19,
      name: 'Internal Transfer',
      wallet: formatIfExists(data.intTransfer.wallet),
      account: formatIfExists(data.intTransfer.account),
      result: formatIfExists(data.intTransfer.all),
    },
    {
      key: 3,
      name: 'Trade',
      wallet: formatIfExists(data.trade.wallet),
      account: formatIfExists(data.trade.account),
      result: formatIfExists(data.trade.all),
      children: [
        {
          key: 31,
          name: 'Trading result',
          wallet: formatIfExists(data.trade.tradingResult.wallet),
          account: formatIfExists(data.trade.tradingResult.account),
          result: formatIfExists(data.trade.tradingResult.all),
        },
        {
          key: 32,
          name: 'Balance fix',
          wallet: formatIfExists(data.trade.balanceFix.wallet),
          account: formatIfExists(data.trade.balanceFix.account),
          result: formatIfExists(data.trade.balanceFix.all),
        },
        {
          key: 33,
          name: 'Transaction commission',
          wallet: formatIfExists(data.trade.commission.wallet),
          account: formatIfExists(data.trade.commission.account),
          result: formatIfExists(data.trade.commission.all),
        },
      ],
    },
    {
      key: 4,
      name: (
        <Tooltip title="Балансовые операции">
          <div>Balance operations</div>
        </Tooltip>
      ),
      wallet: formatIfExists(data.balanceOperation.wallet),
      account: formatIfExists(data.balanceOperation.account),
      result: formatIfExists(data.balanceOperation.all),
    },
    {
      key: 5,
      name: (
        <Tooltip title="Проторгованный и доступный к выводу на 1 число бонус 111">
          <div>Bonus $111 available WD</div>
        </Tooltip>
      ),
      account: <div>{formatIfExists(data.bonusAvailable.wallet)}</div>,
      result: formatIfExists(data.bonusAvailable.all),
    },
    {
      key: 6,
      name: (
        <Tooltip title="Бонус выведенный">
          <div>Bonus $111</div>
        </Tooltip>
      ),
      wallet: (
        <Tooltip title="Вывели на кошелек" placement="topLeft">
          <div>{formatIfExists(data.bonus.wallet)}</div>
        </Tooltip>
      ),
      account: (
        <Tooltip title="Вывели на MT аккаунт" placement="topLeft">
          <div>{formatIfExists(data.bonus.account)}</div>
        </Tooltip>
      ),
      result: formatIfExists(data.bonus.all),
    },
    {
      key: 20,
      name: (
        <Tooltip title="Средства, которые можно вывести без проторговки (клиент ещё не выбрал способ получения) + полный профит, ожидающий проторговки">
          <div>Невыведенные $150</div>
        </Tooltip>
      ),
      wallet: '',
      account: '',
      result: formatIfExists(data.bonus150Unreceived.all),
    },
    {
      key: 21,
      name: (
        <Tooltip title="Выведенные без проторговки средства + полный профит, выведенный с проторговкой">
          <div>Выведенные $150</div>
        </Tooltip>
      ),
      wallet: formatIfExists(data.bonus150Received.wallet),
      account: formatIfExists(data.bonus150Received.account),
      result: formatIfExists(data.bonus150Received.all),
    },
    {
      key: 7,
      name: 'CT commission',
      wallet: (
        <Tooltip
          title="Начисление трейдеру за подписку за вычетом нашей комиссии"
          placement="topLeft"
        >
          <div>{formatIfExists(data.ctCommission.wallet)}</div>
        </Tooltip>
      ),
      account: (
        <Tooltip title="Списания с инвестора за подписку" placement="topLeft">
          <div>{formatIfExists(data.ctCommission.account)}</div>
        </Tooltip>
      ),
      result: formatIfExists(data.ctCommission.all),
    },
    {
      key: 8,
      name: 'Crowns',
      wallet: (
        <Tooltip
          title="Сумма начислений на баланс кошелька за потраченные короны"
          placement="topLeft"
        >
          <div>{formatIfExists(data.crowns.wallet)}</div>
        </Tooltip>
      ),
      account: '',
      result: formatIfExists(data.crowns.all),
    },
    {
      key: 9,
      name: 'IB wallets',
      wallet: (
        <Tooltip
          title="Партнерская комиссия от торговли прямых клиентов + партнерская комиссия от партнеров"
          placement="topLeft"
        >
          <div>{formatIfExists(data.ibWallet.wallet)}</div>
        </Tooltip>
      ),
      account: (
        <Tooltip title="Кэшбэк клиентам партнера" placement="topLeft">
          <div>{formatIfExists(data.ibWallet.account)}</div>
        </Tooltip>
      ),
      result: formatIfExists(data.ibWallet.all),
    },
    {
      key: 10,
      name: 'NOVA dividends',
      wallet: formatIfExists(data.novaDividend.wallet),
      account: formatIfExists(data.novaDividend.account),
      result: formatIfExists(data.novaDividend.all),
    },
    {
      key: 11,
      name: 'NOVA sale',
      wallet: formatIfExists(data.novaSale.wallet),
      account: formatIfExists(data.novaSale.account),
      result: formatIfExists(data.novaSale.all),
    },
    {
      key: 12,
      name: (
        <Tooltip
          title="Выводы, трейдинг комишен, Bonus$111  на счет и аккаунты, копитрейд на аккаунты и Нова девиденды - идут со знаком минус от общей суммы пасcивов. Те это то, что их уменьшает. Результаты торговли могут уменьшать, могут увеличивать.
Все остальное пассивы увеличивает."
        >
          <div>Exchange difference</div>
        </Tooltip>
      ),
      wallet: formatIfExists(data.exchangeDifference.wallet),
      account: formatIfExists(data.exchangeDifference.account),
      result: formatIfExists(data.exchangeDifference.all),
    },
    {
      key: 13,
      name: 'Final balance',
      wallet: formatIfExists(data.finalBalance.wallet),
      account: formatIfExists(data.finalBalance.account),
      result: (
        <Tooltip title={finalBalanceTooltip} placement="topLeft">
          <div>{formatIfExists(data.finalBalance.all)}</div>
        </Tooltip>
      ),
    },
    {
      key: 14,
      name: 'Balance change',
      wallet: formatIfExists(data.balanceChange.wallet),
      account: formatIfExists(data.balanceChange.account),
      result: (
        <Tooltip title={balanceChangeRDCTooltip} placement="topLeft">
          <div>{formatIfExists(data.balanceChange.all)}</div>
        </Tooltip>
      ),
    },
    {
      key: 15,
      name: 'Проверка Balance change',
      wallet: '',
      account: '',
      result: (
        <Tooltip title={diffBalanceChangeTooltip} placement="topLeft">
          <div>{diffBalanceChange}</div>
        </Tooltip>
      ),
    },
  ]
}
